<stx-generic-wide-page>
  @if (isViewDashboardForUser()) {
  <stx-password-expiry></stx-password-expiry>
  }
  <stx-page-header [name]="'users' | translate"></stx-page-header>
  <stx-user-search> </stx-user-search>
  <div class="data-section">
    <stx-data-table
      [dataProvider]="searchResultsDataProvider"
      [config]="{ topPaginator: true, hideUninitialized: true, stickyColumnClass: 'sticky-first' }"
    >
      <tr mat-row *matRowDef="let row; columns: []"></tr>
    </stx-data-table>
  </div>
</stx-generic-wide-page>
